import { initializeApp } from 'firebase/app';

const firebaseConfig = {
    apiKey: 'AIzaSyDhi-RpcEX7I90u2Cnyu6aQ7nqr4NVn-cc',
    authDomain: 'dashboard-c5c87.firebaseapp.com',
    projectId: 'dashboard-c5c87',
    storageBucket: 'dashboard-c5c87.appspot.com',
    messagingSenderId: '581124479999',
    appId: '1:581124479999:web:1692d983695ca7cbaee5ca',
    measurementId: 'G-8LWNYPHME3',
};

export const app = initializeApp(firebaseConfig);
